<template>
	<svg :class="{'reverse': reverse, 'inverse':inverse, 'vertical':vertical}" :style="style" viewBox="0 0 1019 967" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path :class="classObject" d="M536.639 0H3.31883L484.948 481.629L0 966.576H533.321L1018.27 481.629L536.639 0Z" />
	</svg>

</template>

<script>
export default {
	name: 'chevron',
	props: {
		color: {
			type: String,
			default: '',
		},
		height: {
			type: [Number, String],
			default: 50,
		},
		xoffset: {
			type: String,
			default: null,
		},
		yoffset: {
			type: String,
			default: null,
		},
		index: {
			type: Number,
			default: 1,
		},
		reverse: {
			type: Boolean,
			default: false,
		},
		inverse: {
			type: Boolean,
			default: false,
		},
		vertical: {
			type: Boolean,
			default: false,
		},
		absolute: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		width() {
			return Math.round(Number(this.height) / 0.948)
		},
		classObject() {
			let _class = {}
			_class[this.color] = true
			_class['inverse'] = this.inverse

			return _class
		},
		style() {
			let style = this.xoffset || this.yoffset ? `transform: ` : ``
			style = ``
			if (this.xoffset) {
				style += `left: ${this.xoffset}; `
			}
			if (this.yoffset){
				style += `top: ${this.yoffset}; `
			}
			if (this.index) {
				style += `; z-index: ${this.index} `
			}
			if (this.absolute) {
				style += `; position: absolute `
			}

			return style
		},
	},
}
</script>

<style scoped lang="scss">
svg {
	path {
		fill: var(--color, var(--color--gold));
		transition: fill linear 150ms;
	}
	pointer-events: none;

	@include modules.media-query('phone') {
		display: none;
	}
}

.gold {
	fill: var(--color--gold);

	&.inverse {
		fill: var(--color--background);
		stroke: var(--color--gold);
	}
}

.yellow {
	fill: var(--color--yellow);

	&.inverse {
		fill: var(--color--background);
		stroke: var(--color--yellow);
	}
}

.mint {
	fill: var(--color--mint);

	&.inverse {
		fill: var(--color--background);
		stroke: var(--color--mint);
	}
}

.orange {
	fill: var(--color--orange);

	&.inverse {
		fill: var(--color--background);
		stroke: var(--color--orange);
	}
}

.hunter {
	fill: var(--color--hunter-green);

	&.inverse {
		fill: var(--color--background);
		stroke: var(--color--hunter-green);
	}
}

.green {
	fill: var(--color--dark-green);

	&.inverse {
		fill: var(--color--background);
		stroke: var(--color--dark-green);
	}
}

.cream {
	fill: var(--color--cream);

	&.inverse {
		fill: var(--color--hunter-green);
		stroke: var(--color--cream);
	}
}

.white {
	fill: var(--color--background);

	&.inverse {
		fill: var(--color--background);
		stroke: var(--color--background);
	}
}

.reverse {
	transform: rotate(180deg) !important;
	transform-origin: center center;
}

.vertical {
	transform: rotate(90deg) !important;
	transform-origin: center center;

	&.reverse {
		transform: rotate(270deg) !important;
	}
}
</style>
